import { action } from 'typesafe-actions';
import { LoginObject, User, GlobalErrorObject } from '../../Modal/User';
import { Constants } from './userTypes';

export function storeLoginStatus(isLogin: boolean) {
    return action(
        Constants.SET_LOGIN_STATUS, {
        isLogin
    });
}

export function storeSession(loginRes: LoginObject) {
    return action(
        Constants.SET_USER_SESSION, {
        loginRes
    });
}

export function storeUsersList(payload: User[]) {
    return action(
        Constants.SET_USERSLIST, {
        usersList: payload
    })
}
export function globalErrorResp(globalerrorRes: any | GlobalErrorObject) {
    return action(
        Constants.SET_USERSERRORRES, {
        globalerrorRes
    });
}